import React from "react";
import { recentSold } from "../../mock";
import SwipeRow from "./SwipeRow";
import { BedDouble, Bath, Ruler, ArrowRight } from "lucide-react";

const SoldCard = ({ item }) => (
  <div className="group cursor-pointer">
    <div className="relative overflow-hidden bg-neutral-200 aspect-[4/3]">
      <img src={item.image} alt={item.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
      <span className="absolute top-4 left-4 bg-[#0d0d0d]/85 text-white text-[10px] tracking-luxe px-3 py-1.5 uppercase">{item.tag}</span>
      <span className="absolute bottom-4 left-4 bg-[#b4936a] text-white text-[11px] tracking-luxe-sm px-3 py-1.5">{item.when}</span>
    </div>
    <div className="pt-5">
      <p className="font-serif-display text-2xl text-[#1a1a1a]">{item.price}</p>
      <h3 className="text-[13px] tracking-luxe-sm uppercase text-neutral-700 mt-1">{item.name}</h3>
      <p className="text-[11px] tracking-luxe-sm text-neutral-500 uppercase">{item.address}</p>
      <div className="flex items-center gap-4 text-[12px] text-neutral-600 mt-3">
        <span className="flex items-center gap-1"><BedDouble size={14} /> {item.beds}</span>
        <span className="flex items-center gap-1"><Bath size={14} /> {item.baths}</span>
        <span className="flex items-center gap-1"><Ruler size={14} /> {item.sqft}</span>
      </div>
    </div>
  </div>
);

const RecentlySold = () => (
  <section id="recent-sold" className="bg-white py-24 md:py-32">
    <div className="max-w-[1700px] mx-auto px-6 md:px-10">
      <div className="flex items-end justify-between mb-12 reveal">
        <div>
          <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-3">Just Sold</p>
          <h2 className="font-serif-display text-4xl md:text-5xl font-light text-[#1a1a1a]">Our Recent Sales</h2>
        </div>
        <a href="https://www.zillow.com/profile/Omer%20Reshid" target="_blank" rel="noopener noreferrer" className="hidden md:flex items-center gap-2 text-[11px] tracking-luxe uppercase text-[#1a1a1a] hover:text-[#b4936a] transition-colors border-b border-[#1a1a1a] hover:border-[#b4936a] pb-1">
          View All on Zillow <ArrowRight size={14} />
        </a>
      </div>
      <div className="reveal">
        <SwipeRow testid="recent-sales-swipe">
          {recentSold.map((item, i) => (
            <SoldCard key={i} item={item} />
          ))}
        </SwipeRow>
      </div>
    </div>
  </section>
);

export default RecentlySold;
